import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import PostCard from "../components/PostCard";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PostPage = () => {
  const { postId } = useParams();
  const { token } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPost = async () => {
      try {
        const res = await axios.get(`${API}/posts/${postId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPost(res.data.post);
      } catch (err) {
        console.error("Failed to load post", err);
      } finally {
        setLoading(false);
      }
    };
    loadPost();
  }, [postId, token]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      <Navbar />
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {loading ? (
            <p className="text-center text-gray-500 dark:text-slate-400">Loading post…</p>
          ) : post ? (
            <PostCard post={post} hideSkip={true} />
          ) : (
            <p className="text-center text-gray-500 dark:text-slate-400">Post not found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostPage;
